import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/contact";

export default function FloatingContact() {
  const msg = "Здравейте, Айлян! Интересувам се от вашите цветя.";

  return (
    <motion.a
      href={whatsappLink(msg)}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, duration: 0.4 }}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3.5 rounded-full text-sm font-medium shadow-xl hover:brightness-95 hover:pr-6 transition-all duration-300"
      aria-label="Пишете ни в WhatsApp"
      data-testid="contact-whatsapp"
    >
      <MessageCircle className="w-5 h-5" strokeWidth={2} />
      <span className="hidden sm:inline">Пишете ни</span>
    </motion.a>
  );
}
